<template>
	<el-row>
		<el-col :span="8"></el-col>
		<el-col :span="8" align="center">
			<order-jobs-search-component @picked="onJobPicked" />
		</el-col>
		<el-col :span="8"></el-col>
	</el-row>

	<el-row>
		<el-col>
			<div class="base-form form" style="margin: 0 0 2rem; min-width: 100%;">
				<div style="display: flex;">
					<div style="flex-wrap: wrap;">
						<order-auto-schedule-jobs-component
							:order="order"
							@scheduled="onJobsAssigneesAutoScheduled"
						/>
					</div>
					&nbsp;
					<order-timeline-modal-component 
						:schedule-date="order.scheduledStartDate"
						:order="order"
						:load-schedule-async-handler="loadJobsScheduleAsyncDelegate"
						@item-updated="onJobAssigneeScheduleUpdate"
					/>
				</div>
			</div>
		</el-col>
	</el-row>

	<el-row>
		<el-col :span="24">
			<div class="order-jobs-table el-table--fit el-table--enable-row-transition has-footer el-table el-table--layout-fixed is-scrolling-none"> 
				<div class="el-table__inner-wrapper">
					<table class="el-table__header" border="0" cellpadding="0" cellspacing="0" style="width:100%">
						<thead>
							<tr>
								<th class="el-table_2_column_9 is-leaf el-table__cell" width="1%">
									<div class="cell"></div>
								</th>
								<th class="el-table_2_column_9 is-leaf el-table__cell" width="74px">
									<div class="cell"></div>
								</th>
								<th class="el-table_2_column_10 is-leaf el-table__cell" width="18%">
									<div class="cell">Компонент</div>
								</th>
								<th class="el-table_2_column_11 is-leaf el-table__cell" width="14%">
									<div class="cell">Операция</div>
								</th>
								<th class="el-table_2_column_12 is-leaf el-table__cell" width="8%">
									<div class="cell">Стоимость НЧ</div>
								</th>
								<th class="el-table_2_column_13 is-leaf el-table__cell" width="8%">
									<div class="cell">Кол-во часов</div>
								</th>
								<th class="el-table_2_column_16 is-leaf el-table__cell" width="8%">
									<div class="cell">Скидка (%)</div>
								</th>
								<th class="el-table_2_column_16 is-leaf el-table__cell" width="8%">
									<div class="cell">Менеджер</div>
								</th>
								<th class="el-table_2_column_16 is-leaf el-table__cell" width="8%">
									<div class="cell">Начало работы</div>
								</th>
								<th class="el-table_2_column_16 is-leaf el-table__cell" width="8%">
									<div class="cell">Завершение работы</div>
								</th>
								<th class="el-table_2_column_17 is-leaf el-table__cell" width="8%">
									<div class="cell">Итого (р.)</div>
								</th>
								<th class="el-table_2_column_18 is-leaf el-table__cell" width="8%">
									<div class="cell">Субподряд</div>
								</th>
								<th class="el-table_2_column_19 is-leaf el-table__cell" width="74px">
									<div class="cell"></div>
								</th>
							</tr>
						</thead>												
						<table-draggable-component
							v-if="orderJobs?.length"
							v-model:items="orderJobs"
							@reordered="emitJobsUpdate">
							<template #item="{ element: job, index }">
								<td width="100%" colspan="13">
									<table cellpadding="0" cellspacing="0" width="100%">
										<tbody>
											<tr>
												<td width="1%" class="el-table__cell">
													<div class="cell">
														<expand-button-component v-model="job.jobExpanded" />
													</div>
												</td>

												<td width="74px" class="el-table__cell">
													<div class="cell">
														<el-button
															:icon="filesIcon"
															circle
															@click="(e) => onTableCloneJobClick(job, e)"
														/>
													</div>
												</td>

												<td width="18%" class="el-table__cell">
													<div class="cell">
														{{ job.serviceJob!.component.name }}
														<div v-if=" job.serviceJob!.component.componentGroup">
															<el-text type="info" size="small">{{ job.serviceJob!.component.componentGroup.name }}</el-text>
														</div>
													</div>
												</td>

												<td width="14%" class="el-table__cell">
													<div class="cell">
														<el-select
															v-model="job.serviceJob!.operation.id"
															@change="(i) => onTableJobOperationChange(i, job)"
															size="small">
															<el-option
																v-for="item in job.availableOperations"
																:disabled="checkComponentOperationDisabled(job, item.id)"
																:key="item.id"
																:label="item.name"
																:value="item.id"
															/>
														</el-select>
													</div>
												</td>

												<td width="8%" class="el-table__cell">
													<div class="cell">
														<el-link 
															v-if="!job.isOverriddingCostPerHour" 
															type="primary" 
															:underline="false"
															@click="(e) => onTableJobCostEditClick(job, e)">
															{{ job.overriddenJobCostPerHour ? job.overriddenJobCostPerHour :  job.serviceJob!.category.costPerHour }} руб.
														</el-link>
														<div v-else>
															<el-input-number 
																size="small" 
																@click="(e) => e.stopPropagation()"
																@keydown.esc="(e) => onTableJobCancelCostEditClick(job, e)"
																@change="() => updateJobPrice(job)" 
																v-model="job.overriddenJobCostPerHour" 
																:min="0" />
														</div>
													</div>
												</td>

												<td width="8%" class="el-table__cell">
													<div class="cell">
														<el-input-number 
															size="small" 
															@click="(e) => e.stopPropagation()"
															@change="() => updateJobPrice(job)" 
															:class="{'input-invalid': job.estimationHrsInvalid}"
															v-model="job.estimationHrs" 
															:min="0"
														/>
													</div>
												</td>

												<td width="8%" class="el-table__cell">
													<el-input-number size="small" @change="() => updateJobPrice(job)" v-model="job.discountPercent" :min="-100" :max="100" />
												</td>

												<td width="8%" class="el-table__cell">
													<div class="cell">
														{{ job.manager?.lastname }} {{ `${job.manager?.firstname ? `${job.manager?.firstname?.substring(0,1)}.` : ''}` }}
													</div>
												</td>

												<td width="8%" class="el-table__cell">
													<div class="cell">
														{{ formatJobScheduledStartDate(job) }}
													</div>
												</td>

												<td width="8%" class="el-table__cell">
													<div class="cell">
														{{ formatJobScheduledEndDate(job) }}
													</div>
												</td>

												<td width="8%" class="el-table__cell">
													<div class="cell">
														{{ job.cost }}
													</div>
												</td>

												<td width="8%" class="el-table__cell">
													<div class="cell">
														<el-checkbox 
															v-model="job.isSubcontract" 
															@update:modelValue="() => onTableSubcontractChanged(job)"
														/>
													</div>
												</td>

												<td width="74px" class="el-table__cell">
													<div class="cell">
														<el-button
															:icon="deleteIcon"
															circle
															@click="(e) => onTableDeleteJobClick(index, e)"
														/>
													</div>
												</td>
											</tr>											
										</tbody>
									</table>
									<div v-if="job.jobExpanded">
										<order-job-assignees-table-component
											:job="job"
											:branch-id="order.executiveEntityBranch?.id"
											v-model="job.assignees"
											@update:modelValue="emitJobsUpdate"
										/>
									</div>
								</td>
							</template>
						</table-draggable-component>				
						<tbody v-if="!orderJobs?.length">
							<tr>
								<td class="el-table_2_column_16 el-table__cell" colspan="10" align="center">
									<div class="cell">
										<el-text type="info">В заказ-наряде нет работ ☹️</el-text>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>			
		</el-col>
	</el-row>
</template>

<script lang="ts">
import { WatchStopHandle, watch } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { CircleClose, CirclePlus, Delete, Edit, Files, Warning } from '@element-plus/icons-vue';
import IOrderComponent from './IOrderComponent';
import OrderModel from '@/models/OrderModel';
import OrderJobModel from '@/models/OrderJobModel';
import OrderJobViewModel from '@/ViewModels/OrderJobViewModel';
import OrderJobAssigneeModel from '@/models/OrderJobAssigneeModel';
import EmployeeModel from '@/models/EmployeeModel';
import { ElCheckbox, ElNotification } from 'element-plus';
import EmployeesApiHelper from '@/helpers/api/EmployeesApiHelper';
import JobsApiHelper from '@/helpers/api/JobsApiHelper';
import OrderJobsSearchComponent from './OrderJobsSearchComponent.vue';
import OrderApiHelper from '@/helpers/api/OrderApiHelper';
import ServiceJobModel from '@/models/ServiceJobModel';
import TableDraggableComponent from '@/components/TableDraggableComponent.vue'
import OrderTimelineModalComponent from './OrderTimelineModalComponent.vue';
import OrderAutoScheduleJobsComponent from './OrderAutoScheduleJobsComponent.vue';
import EmployeeJobScheduleModel from '@/models/EmployeeJobScheduleModel';
import EmployeesJobsScheduleApiHelper from '@/helpers/api/EmployeesJobsScheduleApiHelper';
import dateOnlyHelper from '@/helpers/dateOnlyHelper';
import timeOnlyHelper from '@/helpers/timeOnlyHelper';
import store from '@/store';
import CounterpartyType from '@/models/enums/CounterpartyType';
import OrderJobAssigneesTableComponent from './OrderJobAssigneesTableComponent.vue';
import ExpandButtonComponent from '../ExpandButtonComponent.vue';
import CounterpartyModel from '@/models/CounterpartyModel';

@Options({
	props: {
		order: Object,
		jobs: Array
	},
	emits: ['update:jobs'],
	components: {
		ElCheckbox,
		Warning,		
		CircleClose,
		OrderJobsSearchComponent,
		OrderTimelineModalComponent,
		OrderAutoScheduleJobsComponent,
		TableDraggableComponent,
		OrderJobAssigneesTableComponent,
		ExpandButtonComponent
	}
})
export default class OrderJobsComponent extends Vue implements IOrderComponent {
	/** props */
	order!: OrderModel;
	jobs!: Array<OrderJobModel>;

	/** constants */
	circleIcon = CirclePlus;
	deleteIcon = Delete;
	filesIcon = Files;
	editIcon = Edit;	
	// define type for counterparties a registered as sub-contractors
	counterpartyContractorType = CounterpartyType.Contractor;
	orderApiHelper = new OrderApiHelper(store.getters.jwt);
	managers: Array<EmployeeModel> = [];

	/** view-models */
	orderJobs = new Array<OrderJobViewModel>();	

	watchJobsHandler: WatchStopHandle | null = null;

	mounted() {
		this.fetchManagersAsync();

		this.watchJobsHandler = watch(
			() => this.jobs,
			(v) => {
				if (!v?.length) {
					this.orderJobs = [];
				} else {
					this.orderJobs = v.map((_, i) => {
						const jobViewModel = new OrderJobViewModel(_);
						jobViewModel.vmId = i + 1;
						jobViewModel.isOverriddingCostPerHour = !!jobViewModel.overriddenJobCostPerHour;
						return jobViewModel;
					});
				}
			}
		);
	}

	unmounted() {
		if (this.watchJobsHandler) {
			this.watchJobsHandler();
		}
	}

	emitJobsUpdate() {
		this.$emit('update:jobs', this.orderJobs);
	}

	async onJobPicked(job: OrderJobViewModel) {
		const jobId = job.serviceJob!.id;
		const isJobAlreadyAdded = !!this.orderJobs.find(existingOrderJob => existingOrderJob.serviceJob?.id == jobId);
		let newOrderJob: OrderJobViewModel | null = null;
		if (isJobAlreadyAdded) {
			const serviceJob = await this.findNotAssignedJobOfComponentAsync(job);
			// there is one (or more) of possible combinations of component's jobs
			if (serviceJob?.id) {			
				newOrderJob = this.cloneOrderJobViewModel(job, serviceJob);
			} 
			// out of possible combinations of component's jobs, nothing to add
			// else { alert('this component can\'t be added - duplication of component-operations is prohibited') }
		} else {
			newOrderJob = new OrderJobViewModel(job);
		}

		if (newOrderJob?.serviceJob?.id) {
			newOrderJob.cost = await this.orderApiHelper.getJobCostAsync(job);
			this.orderJobs.push(newOrderJob);
			newOrderJob.vmId = this.orderJobs.length;
			this.emitJobsUpdate();
		}
	}
	
	cloneOrderJobViewModel(cloningOrderJob: OrderJobViewModel, serviceJob: ServiceJobModel) {
		const newOrderJob = new OrderJobViewModel(cloningOrderJob);
		newOrderJob.id = 0;
		newOrderJob.vmId = 0;
		newOrderJob.serviceJob = serviceJob;
		if (newOrderJob.assignees?.length) {
			newOrderJob.assignees.forEach(a => {
				if (a.scheduledDate) {
					a.scheduledDate = null;
				}

				if (a.scheduledStartTime) {
					a.scheduledStartTime = null;
				}

				if (a.scheduledEndTime) {
					a.scheduledEndTime = null;
				}

				if (a.scheduledEndDate) {
					a.scheduledEndDate = null;
				}
			});
		}
		newOrderJob.assigneesInvalid = cloningOrderJob.assigneesInvalid;
		newOrderJob.estimationHrsInvalid = cloningOrderJob.estimationHrsInvalid;	
		return newOrderJob;
	}

	async findNotAssignedJobOfComponentAsync(orderJob: OrderJobViewModel) : Promise<ServiceJobModel | null> {
		const componentId = orderJob.serviceJob!.component.id;
		const componentExistingOperationIds = new Array<number>();
		this.orderJobs.forEach(_ => {
			if (_.serviceJob?.component.id == componentId) {
				componentExistingOperationIds.push(_.serviceJob.operation.id);
			}
		});

		const newOperation = orderJob.availableOperations?.find(_ => componentExistingOperationIds.every(__ => _.id != __));

		if (!newOperation) {
			return null;
		}

		try {
			const jobsApiHelper = new JobsApiHelper();
			const serviceJobModel = await jobsApiHelper.getJobByComponentIdAndOperationIdAsync(store.getters.jwt, componentId, newOperation.id);		
			return serviceJobModel;
		} catch (e) {
			console.error(`Unable to find a job with component #${componentId} and operation #${newOperation.id}`);
			return null;
		}
	}

	onTableCloneJobClick(orderJob: OrderJobViewModel, e: Event) {
		e.stopPropagation();
		this.findNotAssignedJobOfComponentAsync(orderJob)
			.then(serviceJob => {
				if (!serviceJob?.id) {
					return;
				}
				
				const clonedOrderJob = this.cloneOrderJobViewModel(orderJob, serviceJob);

				this.orderApiHelper
					.getJobCostAsync(clonedOrderJob)
					.then(cost => {
						clonedOrderJob.cost = cost;						
						this.orderJobs.push(clonedOrderJob);						
						clonedOrderJob.vmId = this.orderJobs.length;
						this.emitJobsUpdate();
					});
			});			
	}

	onTableDeleteJobClick(elementIndex: number,  e: Event) {
		e.stopPropagation();
		this.orderJobs.splice(elementIndex, 1);
		this.emitJobsUpdate();
	}

	/** fires when user overrides job's cost per hour */
	onTableJobCostEditClick(job: OrderJobViewModel, e: Event) {
		e.stopPropagation();
		job.overriddenJobCostPerHour = job.serviceJob!.category.costPerHour;
		job.isOverriddingCostPerHour = true;
	}

	onTableJobCancelCostEditClick(job: OrderJobViewModel, e: Event) {
		e.stopPropagation();

		if (!job.isSubcontract) {
			job.overriddenJobCostPerHour = null;
			job.isOverriddingCostPerHour = false;
		}
	}

	/** fires when job's isSubcontract field changed */
	onTableSubcontractChanged(job: OrderJobViewModel) {
		this
			.$nextTick()
			.then(() => {
				if (job.isSubcontract) {
					const subcontractor = new OrderJobAssigneeModel();
					subcontractor.allocationPercent = 100;
					job.assignees = [ subcontractor ];
				} else {
					job.assignees = [];
				}
				this.emitJobsUpdate();
			});		
	}

	async onTableJobOperationChange(selectedOperationId: number, orderJob: OrderJobViewModel) {
		const jobsApiHelper = new JobsApiHelper();
		const componentId = orderJob.serviceJob!.component!.id;
		const serviceJob = await jobsApiHelper.getJobByComponentIdAndOperationIdAsync(store.getters.jwt, componentId, selectedOperationId);
		if (!serviceJob?.id) {
			ElNotification({
				message: `Ошибка изменения операции`,
				type: 'error',
			});
			return;
		}
		orderJob.serviceJob = serviceJob;		
		orderJob.cost = await this.orderApiHelper.getJobCostAsync(orderJob);
		this.emitJobsUpdate();
	}

	formatJobScheduledStartDate(job: OrderJobViewModel) {
		const jobAssignees = job.assignees;
		if (!jobAssignees?.length) {
			return '';
		}

		const sortedAssigneesArray = jobAssignees.sort(_ => _.assigneeOrder);
		const firstAssignee = sortedAssigneesArray[0];

		if (!firstAssignee.scheduledDate ||
			!firstAssignee.scheduledStartTime) {
			return '';
		}

		return `${this.formatDateOnly(firstAssignee.scheduledDate!)}, ${this.formatTimeOnly(job, firstAssignee.scheduledDate, firstAssignee.scheduledStartTime)}`; 
	}

	formatJobScheduledEndDate(job: OrderJobViewModel) {
		const jobAssignees = job.assignees;
		if (!jobAssignees?.length) {
			return '';
		}

		const sortedAssigneesArray = jobAssignees.sort(_ => _.assigneeOrder);
		const lastAssignee = sortedAssigneesArray[sortedAssigneesArray.length - 1];

		if (!lastAssignee.scheduledDate ||
			!lastAssignee.scheduledStartTime) {
			return '';
		}

		return `${this.formatDateOnly(lastAssignee.scheduledDate!)}, ${this.formatTimeOnly(job, lastAssignee.scheduledDate, lastAssignee.scheduledStartTime)}`; 
	}

	validateAsync(): Promise<boolean> {
		if (!this.orderJobs.length) {
			return Promise.resolve(true);
		}

		let invalidJobs = 0;

		this.orderJobs.map(job => {			
			if (!job.assignees?.length) {
				invalidJobs++;
				job.assigneesInvalid = true;
			}

			if (job.isSubcontract) {
				const jobAssignee = job!.assignees![0];				
				if (!jobAssignee.subcontractor?.id) {
					invalidJobs++;
					job.assigneesInvalid = true;
				}
			} else {
				let jobAllocationPercent = 0;
				job.assignees?.forEach(_ => jobAllocationPercent += _.allocationPercent);
				if (!job.assigneesInvalid &&
					(jobAllocationPercent <= 99 || jobAllocationPercent > 100)) {
					invalidJobs++;
					job.assigneesInvalid = true;
				}

				if (job.estimationHrs <= 0) {
					invalidJobs++;
					job.estimationHrsInvalid = true;
				}
			}
		});

		return Promise.resolve(invalidJobs == 0);
	}	

	async fetchManagersAsync(): Promise<void> {		
		this.managers = await (new EmployeesApiHelper()).getManagersAsync(store.getters.jwt);
	}

	updateJobPrice(orderJob: OrderJobViewModel) {			
		if (!orderJob.estimationHrs) {
			return;
		}

		this.orderApiHelper
			.getJobCostAsync(orderJob)
			.then(cost => orderJob.cost = cost)
			.finally(() => this.emitJobsUpdate());
	}

	checkComponentOperationDisabled(orderJob: OrderJobViewModel, operationId: number) {
		const selectedOperationId = orderJob.serviceJob!.operation.id;
		const jobComponentId = orderJob.serviceJob!.component!.id;
		const jobComponentAssignedOperationIds: Array<number> = [];
		this.orderJobs.map(_ => {
			if (operationId != selectedOperationId &&
				_.serviceJob!.component!.id == jobComponentId) {
				jobComponentAssignedOperationIds.push(_.serviceJob!.operation.id);
			}
		});

		return jobComponentAssignedOperationIds.findIndex(oId => oId == operationId) >= 0;
	}

	/**
	 * fires when current order's jobs automatically scheduled
	 * @param scheduledJobsAssignees all jobs of all orders scheduled on a date
	 */
	onJobsAssigneesAutoScheduled(scheduledJobsAssignees: Array<OrderJobAssigneeModel>) {	
		if (!scheduledJobsAssignees?.length) {
			ElNotification({
				message: 'Автопланирование невозможно',
				type: 'warning',
			});
			return;
		}

		let existingJobsAssigneesCount = 0;
		this.orderJobs.forEach(existingJob => {
			const serviceJobId = existingJob.serviceJob!.id
			const autoScheduledJob = scheduledJobsAssignees.find(
				_ => _.job!.serviceJob!.id == serviceJobId
			);

			if (!autoScheduledJob) {
				return;
			}

			if (!existingJob.isSubcontract) {
				if (existingJob.assignees?.length) {
					scheduledJobsAssignees.forEach(autoAssignee => {

						let existingAssignee = existingJob.assignees!.find(_ =>
							_.employee!.id == autoAssignee.employee!.id &&
							!_.scheduledDate
						);

						if (existingAssignee) {
							existingJobsAssigneesCount++;
							existingAssignee.scheduledDate = autoAssignee.scheduledDate;
							existingAssignee.scheduledEndDate = autoAssignee.scheduledEndDate;
							existingAssignee.scheduledStartTime = autoAssignee.scheduledStartTime;
							existingAssignee.scheduledEndTime = autoAssignee.scheduledEndTime;
							existingAssignee.allocationPercent = autoAssignee.allocationPercent;
						}
					});
				} else {
					const scheduledJobAssignees = scheduledJobsAssignees.filter(
						_ => _.job?.serviceJob?.id == serviceJobId
					);

					existingJob.assignees = scheduledJobAssignees?.map(_ => {
						const a = new OrderJobAssigneeModel();						
						
						a.job = new OrderJobModel(_.job);
						a.job.order = new OrderModel();
						a.job.order.id = this.order.id;
						a.job.order.number = this.order.number;
						a.job.order.scheduledStartDate = this.order.scheduledStartDate;
						a.job.order.vehicle =  this.order.vehicle;

						a.employee = _.employee?.id ? new EmployeeModel(_.employee) : null;
						a.subcontractor = _.subcontractor?.id ? new CounterpartyModel(_.subcontractor) : null;
						a.scheduledDate = _.scheduledDate;
						a.scheduledStartTime = _.scheduledStartTime;
						a.scheduledEndTime = _.scheduledEndTime;
						a.scheduledEndDate = _.scheduledEndDate;
						a.allocationPercent = _.allocationPercent;
						a.duration = _.duration;

						return a;
					});					
				}

				existingJobsAssigneesCount += existingJob.assignees.length;
			}

			if (existingJob.isSubcontract) {
				const currentJobAutoAssignees = scheduledJobsAssignees
					.filter(_ => _.job!.serviceJob!.id == serviceJobId);

				existingJob.assignees = currentJobAutoAssignees.map(autoAssignee => {
					const a = new OrderJobAssigneeModel();

					a.job = new OrderJobModel(existingJob);
					a.job.order = new OrderModel();
					a.job.order.id = this.order.id;
					a.job.order.number = this.order.number;
					a.job.order.scheduledStartDate = this.order.scheduledStartDate;
					a.job.order.vehicle = this.order.vehicle;

					a.subcontractor = new CounterpartyModel(autoAssignee.subcontractor);
					a.scheduledDate = autoAssignee.scheduledDate;
					a.scheduledStartTime = autoAssignee.scheduledStartTime;
					a.scheduledEndTime = autoAssignee.scheduledEndTime;
					a.scheduledEndDate = autoAssignee.scheduledEndDate;
					a.allocationPercent = autoAssignee.allocationPercent;
					a.duration = autoAssignee.duration;

					return a;
				});

				existingJobsAssigneesCount += existingJob.assignees.length;
			}
		});

		if (existingJobsAssigneesCount != scheduledJobsAssignees.length) {
			ElNotification({
				message: 'Не на все работы были назначены исполнители',
				type: 'warning',
			});
		} else {
			ElNotification({
				message: 'Все работы текущего заказ-наряда запланированы',
				type: 'success',
			});
		}

		this.emitJobsUpdate();
	}

	/* fires when user changes jobAssignee schedule on timeline graph */
	onJobAssigneeScheduleUpdate(updatedAssigneeSchedule: EmployeeJobScheduleModel) {
		let job: OrderJobViewModel | undefined;

		if (updatedAssigneeSchedule.virtual) {
			job = this.orderJobs?.find(_ => 
				_.serviceJob?.id == updatedAssigneeSchedule.job?.serviceJob?.id
			);
		} else {
			this.orderJobs?.forEach(j => {
				if (job) {
					return;
				}

				const _jobAssignee = j.assignees?.find(a => a.id == updatedAssigneeSchedule.orderJobAssigneeId);
				if (_jobAssignee) {
					job = j;
					return;
				}
			});
		}

		if (job) {
			const assignee = job.assignees?.find(_ => _.employee?.id == updatedAssigneeSchedule.employee?.id);

			if (assignee) {
				assignee.scheduledDate 		= updatedAssigneeSchedule.scheduledDate;
				assignee.scheduledStartTime = updatedAssigneeSchedule.scheduledStartTime;
				assignee.scheduledEndTime 	= updatedAssigneeSchedule.scheduledEndTime;
				assignee.scheduledEndDate 	= updatedAssigneeSchedule.scheduledEndDate;
				
				let totalEstimationHrs = 0;
				job.assignees?.forEach(_ => {					
					if (!_.scheduledDate ||
						!_.scheduledStartTime ||
						!_.scheduledEndDate ||
						!_.scheduledEndTime) {
						return;
					}

					const sTime: any = timeOnlyHelper.toDate(_.scheduledDate, _.scheduledStartTime);
					const eTime: any = timeOnlyHelper.toDate(_.scheduledEndDate, _.scheduledEndTime);

					const diffTime = eTime - sTime;
					const diffHours = Math.round(diffTime / (1000 * 60 * 60) * 100) / 100;
					totalEstimationHrs += diffHours;
				});

				if (job.estimationHrs != totalEstimationHrs) {
					job.estimationHrs = totalEstimationHrs;
					this.orderApiHelper
						.getJobCostAsync(job)
						.then(cost => job!.cost = cost)
						.finally(() => this.emitJobsUpdate());
				} else {
					this.emitJobsUpdate();
				}
			}
		}
	}
	
	/** formats TimeOnly: 10:30 */
	formatTimeOnly(selectedJob: OrderJobViewModel, startDate: string, startTime: string) {	
		const [sh, sm] = startTime.split(':').map(Number);	
		const startTimeOnly = `${sh < 10 ? '0' + sh : sh}:${sm < 10 ? '0' + sm : sm}`;
		const t = timeOnlyHelper.toDate(startDate, startTime);
		t.setTime(t.getTime() + (selectedJob.estimationHrs * 60 * 60 * 1000));		
		const endTimeOnly = `${t.getHours() < 10 ? '0' + t.getHours() : t.getHours()}:${t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()}`;

		return `${startTimeOnly} - ${endTimeOnly}`;
	}

	/** formats DateOnly to long date: 1 января 2025? */
	formatDateOnly(dateOnly: string) {
		if (!dateOnly?.length) {
			return '';
		}

		const [year, month, day] = dateOnly.split('-').map(Number);		
		const nowYear = new Date().getFullYear();
		let fullMonth = '';
		switch(month) {
			case 1: fullMonth = 'января'; 	break;			
			case 2: fullMonth = 'февраля'; 	break;
			case 3: fullMonth = 'марта'; 	break;
			case 4: fullMonth = 'апреля'; 	break;
			case 5: fullMonth = 'мая'; 		break;
			case 6: fullMonth = 'июня'; 	break;
			case 7: fullMonth = 'июля'; 	break;
			case 8: fullMonth = 'августа'; 	break;
			case 9: fullMonth = 'сентября'; break;
			case 10: fullMonth = 'октября'; break;
			case 11: fullMonth = 'ноября'; 	break;
			case 12: fullMonth = 'декабря';	break;
		}

		return `${day} ${fullMonth}${year == nowYear ? '' : ` ${year}`}`;
	}

	loadJobsScheduleAsyncDelegate(branchId: number, date: Date) : Promise<Array<EmployeeJobScheduleModel>> {
		return new EmployeesJobsScheduleApiHelper().getJobsSchedule(
			branchId, 
			dateOnlyHelper.date(date),
			store.getters.jwt
		);
	}
}
</script>

<style>
	.order-jobs-table {

	}

		.order-jobs-table tr {
			cursor: pointer;
		}

			.order-jobs-table tr.active-row {
				background: var(--el-color-primary-light-9);
			}

		.order-jobs-table tr:hover:not(.active-row) {
			background: var(--el-color-info-light-9);
		}		

	.order-jobs-assignees-table {
		border: 1px solid var(--el-color-primary);
		border-radius: var(--el-border-radius-base);
		margin-top: 1.4rem;
	}
</style>